import TaskListView from "./views/taskListView"
import { Routes, Route } from "react-router"
import TaskCreateUpdateView from "./views/taskCreateUpdateView"
import OTcreateView from "./views/OTcreateView"
import OTDeatilView from "./views/OTDeatilView"
import { CanAuth } from "../../shared/components/CanAuth"
import TaskCalendarView from "./views/taskCalendarView"
import ScheduledView from "./views/scheduledView"
import PlanTaskView from "./views/planTaskView"

export default function TaskRouter() {
    return (
        <Routes>
            <Route path="/wo" element={<CanAuth><TaskListView /></CanAuth>} />
            <Route path="/wo/create" element={<CanAuth><TaskCreateUpdateView /></CanAuth>} />
            <Route path="/wo/create-ot" element={<CanAuth><OTcreateView /></CanAuth>} />
            <Route path="/wo/detail-ot/:hash_code" element={<CanAuth><OTDeatilView /></CanAuth>} />
            <Route path="/wo/calendar" element={<CanAuth><TaskCalendarView /></CanAuth>} />
            <Route path="/scheduled" element={<CanAuth><PlanTaskView /></CanAuth>} />
            <Route path="/scheduled/plan/:code_group?" element={<CanAuth><ScheduledView /></CanAuth>} />
        </Routes>
    )
}